export const defaultLabServicesIds = ['a1oPB000006HRtiYAG', 'a1oPB000006YkkyYAC'];
